<script setup>
  import { computed } from 'vue';

  import arrowIcon from '@/assets/images/home/button-arrow.svg';

  const props = defineProps({
    variant: {
      type: String,
      default: 'primary',
      validator: (value) => ['primary', 'outline'].includes(value),
    },
    // compact: one size step down at every breakpoint
    size: {
      type: String,
      default: 'default',
      validator: (value) => ['default', 'compact'].includes(value),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  });

  const sizeClasses = computed(() =>
    props.size === 'compact'
      ? 'xl:py-3.5 xl:pr-4 xl:pl-7.5 xl:text-[22px]/8'
      : 'md:py-3.5 md:pr-4 md:pl-7.5 md:text-[22px]/8 xl:py-4 xl:pl-8 xl:text-2xl/8'
  );
</script>

<template>
  <button
    type="button"
    :disabled="loading || undefined"
    :aria-busy="loading || undefined"
    :class="[
      'group inline-flex shrink-0 cursor-pointer items-center justify-center gap-2 rounded-full py-3 pr-3.5 pl-7 text-[20px]/8 font-bold whitespace-nowrap text-white transition-colors',
      sizeClasses,
      'focus-visible:outline-2 focus-visible:outline-offset-4 aria-busy:cursor-wait',
      variant === 'primary' &&
        'bg-blue-light hover:bg-blue focus-visible:outline-blue-light disabled:not-aria-busy:opacity-60',
      variant === 'outline' &&
        'border-3 border-white hover:bg-white/10 focus-visible:outline-white',
    ]"
  >
    <slot />
    <span v-if="loading" class="grid h-8 w-6 shrink-0 place-items-center" aria-hidden="true">
      <span class="size-5 animate-spin rounded-full border-2 border-current border-t-transparent" />
    </span>
    <img
      v-else
      :src="arrowIcon"
      alt=""
      class="h-8 w-auto shrink-0 transition-transform duration-200 group-enabled:group-hover:translate-x-1"
    />
  </button>
</template>
